import { constDropdownData } from "src/app/core/helper/core.data.interface";
import { AppConstant, VALIDATOR_PATTERNS } from "src/app/helper/class/app-constant";
import { formBuilder, formBuilderData, formDynamicValidator, tableColum } from "src/app/helper/interface/response";

export const CHILD_LIST_TBL: tableColum[] = [
    {
        colName: 'profile_img_path',
        colType: 'IMAGE',
        visible: false
    },
    {
        colName: 'name',
        colJoinName: 'profile_img_path'
    },
    {
        colName: 'child_id',
        sort: false,
        isPrimary: true,
        colType: 'CHILD_ID'
    },
    {
        colName: 'child_no',
        title: 'Reg No',
    },
    {
        colName: 'parent',
    },
    {
        colName: 'status',
        colType: 'DROPDOWN',
        filterCol: { apiName: 'child_status', selectPrimaryKey: 'id', selectKeyName: 'child_statusName', type: 'DROPDOWN' }
    },
    {
        colName: 'child_type',
        title: 'Type',
        colType: 'DROPDOWN',
        filterCol: {
            data: [{ child_typeName: 'MK', id: 1 }, { child_typeName: 'Home', id: 2 }],
            selectPrimaryKey: 'id',
            selectKeyName: 'child_typeName',
            type: 'DROPDOWN',
        },
        visible: false
    },
    {
        colName: 'homeName',
        title: 'Home/Project',
    },
    {
        colName: 'home_no',
        title: 'Home/Project No',
    },
    {
        colName: 'gender',
        colType: 'DROPDOWN',
        filterCol: {
            type: 'DROPDOWN',
            data: AppConstant.GENDER,
            selectKeyName: 'genderName',
            selectPrimaryKey: 'id'
        }
    },
    {
        colName: 'total_active_alloted',
        title: 'Alloted',
    },
    {
        colName: 'updated_at',
        title: 'Last Update',
        sort: true,
        colType: 'DATE',
        filterCol: { type: 'DATE', selectKeyName: 'updated_at', yearNavigator: true, monthNavigator: true }
    },
];

export const CHILD_OTHERS_FORM: formBuilder[] = [
    {
        colName: 'blood_group_id',
        title: 'Blood Group ',
        selectKeyName: 'blood_groupName',
        type: 'select',
        apiTblName: 'blood_group'
    },
    {
        colName: 'brief_history',
        type: 'TEXTAREA',
        col_size: 12
    },
    {
        colName: 'hobbies',
        col_size: 4
    },
    {
        colName: 'skill_set',
        col_size: 4
    },
    {
        colName: 'comments',
        title: 'Comment',
        col_size: 4
    },
    {
        colName: 'id',
        col_size: 3,
        hidden: true
    },
    {
        groupTitle: 'Support Document',
        colName: 'aadhar_document',
        title: 'Aadhar Doc',
        type: 'FILE',
        col_size: 3
    },
    {
        colName: 'birth_document',
        title: 'Birth Certificate',
        type: 'FILE',
        col_size: 3
    },
    {
        colName: 'family_img',
        title: 'Family Image',
        type: 'FILE',
        col_size: 3
    },
    {
        colName: 'others_document',
        title: 'Others Doc',
        type: 'FILE',
        col_size: 3
    },
];

export const CHILD_PHY_FORM: formBuilderData[] = [
    { colName: 'id', hidden: true, visible: false },
    {
        colName: 'record_date',
        title: 'Record On',
        type: 'DATE',
        validator: [{ name: 'required' }],
        defaultValue: new Date()
    },
    {
        colName: 'sickness',
    },
    {
        colName: 'height',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER }, { name: 'required' }],
        icon_append: { text: 'CM', category: 'APPEND' },
        info: 'Height measurement in CM'
    },
    {
        colName: 'weight',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER_FLOAT }, { name: 'required' }],
        icon_append: { text: 'KG', category: 'APPEND' },
        info: 'Weight measurement in KG',
    },
    {
        colName: 'health_cond',
        title: 'Health Condition',
        type: 'select',
        validator: [{ name: 'required' }],
        selectPrimaryKey: 'id',
        selectKeyName: 'health_condName',
        data: [{ health_condName: 'Weak', id: 1 }, { health_condName: 'Healthy', id: 2 }, { health_condName: 'Malnourished', id: 3 }]
    },
];

export const CHILD_REPORT_FORM: formBuilderData[] = [
    { colName: 'id', hidden: true, visible: false },
    {
        colName: 'record_date',
        title: 'Record On',
        type: 'DATE',
        validator: [{ name: 'required' }],
        defaultValue: new Date()
    },
    {
        colName: 'sickness',
    },
    {
        colName: 'height',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER }, { name: 'required' }],
        icon_append: { text: 'CM', category: 'APPEND' },
        info: 'Height measurement in CM'
    },
    {
        colName: 'weight',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER_FLOAT }, { name: 'required' }],
        icon_append: { text: 'KG', category: 'APPEND' },
        info: 'Weight measurement in KG',
    },
    {
        colName: 'health_cond',
        title: 'Health Condition',
        type: 'select',
        validator: [{ name: 'required' }],
        selectPrimaryKey: 'id',
        selectKeyName: 'health_condName',
        data: [{ health_condName: 'Weak', id: 1 }, { health_condName: 'Healthy', id: 2 }, { health_condName: 'Malnourished', id: 3 }]
    },
];

export const CHILD_SIBLING_FORM: formBuilderData[] = [{
    colName: 'name',
    col_size: 4,
    validator: [{ name: 'required' }]
},
{
    colName: 'child_id',
    col_size: 4,
    hidden: true,
    colType: 'CHILD_ID'
},
{
    colName: 'id',
    visible: false,
    hidden: true,
    isPrimary: true
},
{
    colName: 'gender',
    apiTblName: 'gender',
    selectKeyName: 'genderName',
    type: 'select',
    col_size: 4,
},
{
    colName: 'dob',
    title: 'Date of Birth',
    type: 'DATE',
    colType: 'DATE',
    monthNavigator: true,
    yearNavigator: true,
    dateFormat: 'dd/mm/yy',
    col_size: 4,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
},
{
    colName: 'email_id',
    col_size: 4,
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }]
},
{
    colName: 'mobile_no',
    col_size: 4,
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
},
{
    colName: 'whatsApp_no',
    col_size: 4,
    visible: false,
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }]
},
{
    colName: 'marital_status_id',
    title: 'Marital Status',
    selectKeyName: 'marital_statusName',
    apiTblName: 'marital_status',
    type: 'select',
    visible: false,
    defaultValue: '1',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
    col_size: 4,
    event: { name: 'change', isCallback: true }
},
{
    colName: 'spouse_name',
    visible: false,
    col_size: 4,
},
{
    colName: 'position_in_family',
    col_size: 4,
    validator: [{ name: 'required' }, { name: 'pattern', funValue: VALIDATOR_PATTERNS.WHOLE_NUMBER }, { name: 'min', funValue: 1 }, { name: 'max', funValue: 12 }]
},
{
    colName: 'status',
    title: 'Current Status',
    apiTblName: 'child_status',
    type: 'select',
    selectKeyName: 'child_statusName',
    event: { name: 'change', isCallback: true },
    validator: [{ name: 'required' }],
    col_size: 4,
},
{
    colName: 'monthly_income',
    title: 'Income in monthly',
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER_FLOAT }],
    visible: false,
    info: 'Monthly Income in Rupees',
    col_size: 4,
},
{
    colName: 'died_on',
    type: 'DATE',
    colType: 'DATE',
    dateFormat: 'dd/mm/yy',
    visible: false,
    dateRange: AppConstant.DEFAULT_FUTURE_DATE_RANGE,
    col_size: 4,
},
{
    colName: 'stayed_category_id',
    title: 'Stayed In',
    // info: `with Parents/Others Hostel with name/${this.shortOrg} Homes`,
    apiTblName: 'stayed_category',
    selectKeyName: 'stayed_categoryName',
    selectPrimaryKey: 'id',
    visible: false,
    col_size: 4,
    type: 'select',
    event: { name: 'change', isCallback: true }
},
{
    colName: "remarks",
    visible: false,
    col_size: 4,
}
];
export const CHILD_PARENT_TYPE: constDropdownData[] = [
    { id: 1, parent_typeName: 'Father' },
    { id: 2, parent_typeName: 'Mother' },
    { id: 3, parent_typeName: 'Guardian' },
]
export const CHILD_PARENT_FORM: formBuilderData[] = [
    {
        colName: 'name',
        validator: [{ name: 'required' }],
        event: { name: 'change', isCallback: true }
    },
    { colName: 'staff_emp_id', visible: true, hidden: true, title: 'Emp Id' },
    {
        colName: 'id',
        visible: false,
        hidden: true,
        isPrimary: true
    },
    {
        colName: 'parent_type',
        hidden: true,
        data: CHILD_PARENT_TYPE,
        selectKeyName: 'parent_typeName',
        type: 'select',
        selectPrimaryKey: 'id',
        validator: [{ name: 'required' }]
    },
    {
        colName: 'gender',
        apiTblName: 'gender',
        selectKeyName: 'genderName',
        type: 'select',
        validator: [{ name: 'required' }],
        defaultValue: 1,
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'occupation',
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'email_id',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }],
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'mobile_no',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }],
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'aadhar',
        title: 'aadhar Number',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.AADHAR_VALIDATOR }, { name: 'required' }],
        event: { name: 'change', isCallback: true },
        visible: false
    },
    {
        colName: 'whatsApp_no',
        validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }],
        event: { name: 'change', isCallback: true },
        visible: false
    },
    {
        colName: 'alive_status',
        title: 'Current Status',
        // data: ALIVE_STATUS,
        type: 'select',
        apiTblName: 'alive_status',
        selectKeyName: 'alive_statusName',
        validator: [{ name: 'required' }],
        visible: false,
        event: { name: 'change', isCallback: true }
    },
    {
        colName: 'died_on',
        type: 'DATE',
        colType: 'DATE',
        dateFormat: 'dd/mm/yy',
        dateRange: AppConstant.DEFAULT_FUTURE_DATE_RANGE,
        event: { name: 'change', isCallback: true },
        visible: false
    },
    {
        colName: 'reason_death',
        title: 'Reason Died',
        event: { name: 'change', isCallback: true },
        visible: false
    },
    {
        colName: "remarks",
        visible: false,
        event: { name: 'change', isCallback: true }
    }
]
export const CHILD_BASIC_FORM: formBuilderData[] = [{
    colName: 'child_no',
    title: 'Child No/Mk No',
    validator: [],
    col_size: 6
},
{
    colName: 'child_id',
    hidden: true,
    visible: true,
},
{
    colName: 'enrolled_date',
    title: 'Date of Enrollment ',
    placeholder: 'Date of Enrollment ',
    type: 'DATE',
    validator: [{ name: 'required' }],
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    yearNavigator: true,
    monthNavigator: true
},
{
    colName: 'name',
    validator: [{ name: 'required' },
    { name: 'pattern', funValue: VALIDATOR_PATTERNS.TEXT, error: 'Name should be valid' }],
    col_size: 6
},
{
    colName: 'gender',
    type: 'select',
    data: AppConstant.GENDER,
    selectKeyName: 'genderName',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
    col_size: 3
},
{
    colName: 'dob',
    title: 'Date of Birth',
    placeholder: 'Date of Birth',
    type: 'DATE',
    validator: [{ name: 'required' }],
    col_size: 3,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    yearNavigator: true,
    monthNavigator: true
},
{ colName: 'child_type', event: { name: 'change', isCallback: true }, apiTblName: 'child_type', selectKeyName: 'child_typeName', type: 'select', validator: [{ name: 'required' }] },
{
    colName: 'stayed_category_id',
    title: 'Present Stayed',
    validator: [],
    apiTblName: 'stayed_category',
    selectKeyName: 'stayed_categoryName',
    selectPrimaryKey: 'id',
    col_size: 3,
    type: 'select',
    event: { name: 'change', isCallback: true }
},
{
    colName: 'home',
    title: 'Home/Projects',
    validator: [],
    type: 'select',
    apiTblName: 'home',
    selectKeyName: 'homeName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    apiFilter: { keyName: 'allow_mk', value: '1', operation: '==' },
    col_size: 3
},
{
    colName: 'religion',
    validator: [],
    type: 'select',
    apiTblName: 'religion',
    selectKeyName: 'religionName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    col_size: 3
},
{
    colName: 'community',
    validator: [],
    type: 'select',
    apiTblName: 'community',
    selectKeyName: 'communityName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    col_size: 3
},
{
    colName: 'email_id',
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }],
    col_size: 3
},
{
    colName: 'mobile_no',
    title: 'Phone Number',
    validator: [
        { name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE, error: 'Mobile No is Requied' },
        { name: 'maxLength', funValue: '10' },
        { name: 'minLength', funValue: '10' }
    ],
    col_size: 3
},
{
    colName: 'whatsApp_no',
    title: 'WhatsApp Number',
    col_size: 3
},
{
    colName: 'position_in_family',
    col_size: 3,
    validator: [{ name: 'required' }, { name: 'pattern', funValue: VALIDATOR_PATTERNS.WHOLE_NUMBER }, { name: 'min', funValue: 1 }, { name: 'max', funValue: 12 }]
},
{
    colName: 'marital_status_id',
    title: 'Marital Status',
    selectKeyName: 'marital_statusName',
    apiTblName: 'marital_status',
    type: 'select',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
    col_size: 3,
    defaultValue: 1,
    event: { name: 'change', isCallback: true }
},
{
    colName: 'spouse_name',
    col_size: 3
},
{
    colName: 'status',
    title: 'Present Status',
    validator: [{ name: 'required', error: 'Status on is Required' }],
    type: 'select',
    apiTblName: 'child_status',
    selectKeyName: 'child_statusName',
    selectPrimaryKey: 'id',
    defaultValue: '',
    col_size: 3,
     event: { isCallback: true, name: 'change' },
},
{colName:'work_sector_fk_id',type:'select',selectKeyName:'work_sectorName',apiTblName:'work_sector',col_size:3},
{colName:'work_sector_description'},
{
    colName: 'allow_yearly_update',
    type: 'checkbox',
    defaultValue: 1,
    col_size: 3,
    selectKeyName: 'allow_yearly_updateName', selectPrimaryKey: 'id',
    data: [{ allow_yearly_updateName: 'Yes', id: 1 }],
},
{
    colName: 'profile_img',
    title: 'Profile Image',
    type: 'FILE',
    validator: [],
    col_size: 3
},
]

export const CHILD_DYNAMIC_VALIDATOR: formDynamicValidator[] = [
    {
        controlName: 'stayed_category_id',
        validatorControl: ['home'],
        hideControl: ['home'],
        value: '1',
    },
    {
        controlName: 'marital_status_id',
        validatorControl: ['spouse_name'],
        hideControl: ['spouse_name'],
        value: '1',
        operation: '>'
    },
    {
        controlName: 'child_type',
        validatorControl: ['stayed_category_id'],
        hideControl: ['stayed_category_id'],
        operation: '==',
        validator: [{ name: 'required' }],
        value: 1
    },
    {
        controlName: 'child_type',
        validatorControl: ['religion', 'community', 'child_no', 'home'],
        operation: '==',
        hideControl: ['religion', 'community', 'child_no', 'home'],
        validator: [{ name: 'required' }],
        value: 2
    },
    {
        controlName: 'status',
        validatorControl: ['work_sector_fk_id', 'work_sector_description'],
        operation: '==',
        hideControl: ['work_sector_fk_id', 'work_sector_description'],
        validator: [{ name: 'required' }],
        value: 3
    }
];

export const CHILD_GIFT_FORM: formBuilder[] = [{
    colName: 'description',
    type: 'TEXTAREA',
    validator: [{ name: 'required', error: 'Description is Required' }],
    col_size: 6
},
{
    colName: 'qty',
    title: 'Total Items',
    validator: [{ name: 'required', error: 'Total Items is Required' },
    { name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER, error: 'Total should be valid' }],
    col_size: 6,
    event: { name: 'change', isCallback: true }
},
{
    colName: 'received_date',
    title: 'Date of Received',
    placeholder: 'Date of Received',
    type: 'DATE',
    validator: [{ name: 'required', error: 'Date of Received is Required' }],
    col_size: 3,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    yearNavigator: true,
    monthNavigator: true
},
{
    colName: 'delivery_date',
    title: 'Date of Distribution',
    placeholder: 'Date of Delivery',
    type: 'DATE',
    validator: [{ name: 'required', error: 'Date of Delivery is Required' }],
    col_size: 3,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    yearNavigator: true,
    monthNavigator: true
},
{
    colName: 'distribution_detail',
    title: 'Distribution Detail',
    validator: [],
},
{
    colName: 'remarks',
},
{
    colName: 'image',
    title: 'Image File',
    placeholder: 'Gifts Attachment',
    type: 'FILE',
},
{
    colName: 'send_email',
    type: 'checkbox',
    defaultValue: 1,
    selectKeyName: 'name', selectPrimaryKey: 'id',
    event: { isCallback: true, name: 'change' },
    data: [{ name: 'Yes', id: 1 }],
},
{
    colName: 'sponsorship_module',
    defaultValue: 2,
    hidden: true
},
{
    colName: 'sponsor_fk_id',
    validator: [{ name: 'required' }],
    hidden: true
},
{
    colName: 'id',
    validator: [],
    hidden: true
}];